const bookDatabase = [
{
    title: "Miracle Morning",
    author: "Hal Elrod",
    summary: "Se lever tôt pour s'offrir un supplément de vie... Et si la clef du bonheur et de la réussite se trouvait dans cette nouvelle résolution ? ",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Evoluer , se transformer",
    nbp: 264,
    id: 2266268554,
    tags: "productivité, se transformer, changer d'état d'esprit",
    url: "https://www.amazon.fr/dp/2412094381?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61KiIJ6siQL._SY342_.jpg",
},
{
    title: "L'Ame du monde",
    author: "Frédéric Lenoir",
    summary: "Sept sages venus des quatres coins du monde se réunissent pour transmettre à deux jeunes adolescents les clés de la sagesse universelle.Une fable initiatique étincelante qui touche le cœur autant que l'intelligence.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Spiritualité & sérénité intérieure",
    category4: "S’ouvrir au monde",
    nbp: 175,
    id: 978221000000000000,
    tags: "philosophie, roman feel-good, s'ouvrir",
    url: "https://www.amazon.fr/dp/2841117022?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41yqPWkE15L._SY445_SX342_PQ90_.jpg",
},
{
    title: "À nos vies, à y croire, à nos âmes sœurs",
    author: "Hélène Jasmé",
    summary: "Exploration des liens profonds de l'amitié.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec les autres",
    category4: "Comprendre et améliorer sa communication avec les autres et viser des relations positives",
    nbp: 390,
    id: "nan",
    tags: "communication, relations sociales, amitié",
    url: "https://www.amazon.fr/dp/B09SVCG44G?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/7169Bd0sHiL._SY342_.jpg",
},
{
    title: "Activez vos talents, ils peuvent changer le monde !",
    author: "Matthieu Dardaillon",
    summary: "Guide pour identifier ses talents et construire une carrière à impact positif.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Esprit d'entreprise & innovation",
    category4: "Changer, découvrir de nouveaux horizons dans sa carrière",
    nbp: 343,
    id: 978238000000000000,
    tags: "penser différemment, confiance, entrepreneuriat",
    url: "https://www.amazon.fr/dp/2379351074?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41UVDh2tbdL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Aime-toi, et beaucoup !",
    author: "Marc Reklau",
    summary: "Cultiver l'amour de soi et surmonter l'anxiété et le doute. Renforcer l’estime de soi et vaincre l’anxiété.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 122,
    id: 978221000000000000,
    tags: "estime de soi, vaincre l'anxiété, confiance en soi",
    url: "https://www.amazon.fr/dp/B0B6LY2PW5?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61bFfTYAJmL._SY342_.jpg",
},
{
    title: "Ainsi parlait Zarathoustra",
    author: "Friedrich Nietzsche",
    summary: "Œuvre philosophique majeure présentant les idées de Nietzsche sur la morale et la société.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Spiritualité & sérénité intérieure",
    category4: "Réflechir sur l'éthique, la morale et la société",
    nbp: 436,
    id: "nan",
    tags: "morale et société, philosophie",
    url: "https://www.amazon.fr/dp/B0B14D2F3Y?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41pNlr457bL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Amour Toxique",
    author: "Diane Borgia",
    summary: "De la codépendance à l’amour de soi.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec les autres",
    category4: "Apprendre à gérer la codépendance et les relations toxiques",
    nbp: 256,
    id: 97829000000000000,
    tags: "toxicité, codépendance, estime de soi",
    url: "https://www.amazon.fr/dp/2923681916?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41ENjqDJcoL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Antideprime",
    author: "Pierre Philip",
    summary: "Routines personnalisées pour un moral au top en 6 semaines.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Améliorer son moral",
    nbp: 197,
    id: 978223000000000000,
    tags: "changer ses habitudes, vaincre l'anxiété, s'affirmer",
    url: "https://www.amazon.fr/dp/2226494200?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41J1WPNDOzL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Avoir raison avec Schopenhauer",
    author: "Guillaume Prigent",
    summary: "Guide pratique pour comprendre et utiliser les stratagèmes argumentatifs de Schopenhauer.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 160,
    id: 2290156744,
    tags: "s'affirmer, influence",
    url: "https://www.amazon.fr/dp/2290156744?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41FT4JBnXDL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Born to Run",
    author: "Christopher McDougall",
    summary: "Un récit captivant sur une tribu de super-coureurs et le lien entre corps, esprit et nature.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du sport",
    nbp: 410,
    id: 2375023358,
    tags: "nature, récit, sport",
    url: "https://www.amazon.fr/dp/2375021495?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61gfWwZaqyL._SY342_.jpg",
},
{
    title: "Coeur brisé apres une rupture",
    author: "Victoria Lane",
    summary: "Conseils pour surmonter une rupture douloureuse.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Apprendre à se relever après un echec",
    nbp: 294,
    id: 978285000000000000,
    tags: "rupture, guérir",
    url: "https://www.amazon.fr/dp/B0DF75YQHM?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/71NoS7u3ChL._SY342_.jpg",
},
{
    title: "Comment se faire des amis",
    author: "Dale Carnegie",
    summary: "Un classique intemporel pour améliorer ses relations interpersonnelles et professionnelles. Techniques pour améliorer les relations interpersonnelles et influencer positivement les autres.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec les autres",
    category4: "Comprendre et améliorer sa communication avec les autres et viser des relations positives",
    nbp: 317,
    id: "nan",
    tags: "communication, relations sociales, amitié",
    url: "https://www.amazon.fr/dp/2253238716?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/410xePLb76L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Competences Essentielles pour une Communication Optimale",
    author: "Gerard Shaw",
    summary: "Techniques pour parler en public, résoudre les conflits et affirmer ses idées.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 172,
    id: 978271000000000000,
    tags: "s'affirmer, savoir présenter",
    url: "https://www.amazon.fr/dp/1958166561?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61Dz3KR9VVL._SY342_.jpg",
},
{
    title: "Confiance en Soi",
    author: "Camille Corbeil",
    summary: "Renforcer l'estime de soi et bâtir une confiance durable.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 123,
    id: 979878000000000000,
    tags: "estime de soi, confiance en soi, s'affirmer",
    url: "https://www.amazon.fr/dp/B09XYWJB5Q?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41Nu1I29qyL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Confiance en soi - Les 7 piliers d’une personnalité puissante",
    author: "Sophie Evrard",
    summary: "Renforcer sa confiance en soi pour développer une personnalité affirmée.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Développer la confiance en soi",
    nbp: 126,
    id: 9791035938,
    tags: "confiance en soi, s'affirmer, évoluer",
    url: "https://www.amazon.fr/dp/1964617049?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41IVrmKyLxL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Confiance en soi en 21 jours",
    author: "Chantal Labeste",
    summary: "Programme structuré pour développer la confiance en soi.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Développer la confiance en soi",
    nbp: 224,
    id: 978281000000000000,
    tags: "confiance en soi, s'affirmer, évoluer",
    url: "https://www.amazon.fr/dp/2813232653?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61lv3wqT9mL._SY342_.jpg",
},
{
    title: "La Confiance Créative: Tous innovateurs avec le Design Thinking",
    author: "Tom Kelley & David Kelley",
    summary: "Développer sa créativité pour innover dans tous les domaines de sa vie.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Travailler et développer sa créativité",
    nbp: 345,
    id: 978233000000000000,
    tags: "innovation, créativité",
    url: "https://www.amazon.fr/dp/2729616136?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41uY8hEJrML._SY445_SX342_PQ90_.jpg",
},
{
    title: "Créativite - Un art de vivre",
    author: "Rick Rubin",
    summary: "Exploration de la créativité comme manière d’être et source d’épanouissement. Réflexions et conseils pour libérer son potentiel créatif.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Travailler et développer sa créativité",
    nbp: 311,
    id: 978238000000000000,
    tags: "innovation, créativité",
    url: "https://www.amazon.fr/dp/2379354006?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/615HM0LfmjL._SY342_.jpg",
},
{
    title: "Dans les forêts de Siberie",
    author: "Sylvain Tesson",
    summary: "Six mois de retraite solitaire en Sibérie, exploration de la solitude et du lien à la nature.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 186,
    id: 978207000000000000,
    tags: "solitude, nature, récit",
    url: "https://www.amazon.fr/dp/2203198826?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41TPlDaOTjL._SY445_SX342_PQ90_.jpg",
},
{
    title: "De la Guimauve dans mes chakras",
    author: "Beatrice Mas",
    summary: "Romance feel-good sur la renaissance de soi et l’amour à 50 ans.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 291,
    id: 978274000000000000,
    tags: "récit, confiance en soi, estime de soi",
    url: "https://www.amazon.fr/dp/2959150953?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41pM1KXVVlL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Deep Work",
    author: "Cal Newport",
    summary: "Stratégies pour se concentrer profondément et maximiser sa productivité. Comment aller au bout de ses idées sans distraction, avec concentration et impact.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Apprendre à être plus effficace et productif",
    nbp: 227,
    id: 979103000000000000,
    tags: "productivité, penser autrement, évoluer",
    url: "https://www.amazon.fr/dp/B06XXVRZJC?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41lb45LtNWL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Dépendance Affective",
    author: "Lucie Muller",
    summary: "Méthode RLD pour sortir de la dépendance affective.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 183,
    id: 979104000000000000,
    tags: "guérir, aller mieux, blessure émotionnelle",
    url: "https://www.amazon.fr/dp/B0DKJTWHP2?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41zDrKYQkWL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Detox de dopamine",
    author: "Thibaut Meurisse",
    summary: "Réduire les distractions numériques et améliorer sa productivité.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Apprendre à être plus effficace et productif",
    nbp: 221,
    id: 978223000000000000,
    tags: "productivité, penser autrement, évoluer",
    url: "https://www.amazon.fr/dp/B0CVF41675?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41Z0OOgmlHL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Devenir Brigitte",
    author: "Xavier Poussard",
    summary: "Exploration de la transformation et de l'influence dans le domaine de la communication.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Parcours de vie inspirants",
    category4: "Réussite et transformation personnelle",
    nbp: 164,
    id: 978281000000000000,
    tags: "communication, influence, histoire de femme",
    url: "https://www.amazon.fr/dp/B0DY4XBHQV?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31nlgIDlkEL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Plus rien ne pourra me blesser: Maîtrisez votre esprit et défiez le destin",
    author: "David Goggins",
    summary: "Le parcours brutal et inspirant d’un ancien Navy SEAL devenu athlète d’ultra-endurance.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Parcours de vie inspirants",
    category4: "Univers du sport",
    nbp: 447,
    id: 978238000000000000,
    tags: "résilience, sport, maladie",
    url: "https://www.amazon.fr/dp/2377530672?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51r6xQV7sEL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Devenir plus organisé",
    author: "Elio Fisher",
    summary: "Conseils pratiques pour mieux s’organiser dans la vie.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 166,
    id: 978221000000000000,
    tags: "organisation, prioriser, productivité",
    url: "https://www.amazon.fr/dp/B0DBB7LZ2V?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41xJ+Et3b7L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Deviens la meilleure version de toi-meme",
    author: "Joumana Z.",
    summary: "Conseils pour s'améliorer personnellement et atteindre son potentiel.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Se lancer dans l'introspection, la quête de sens et de soi",
    nbp: 174,
    id: 2897112867,
    tags: "épanouissement, quête de sens, introspection",
    url: "https://www.amazon.fr/dp/B0D79CKKFR?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31nYGKi-J+L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Entreprendre pour être libre",
    author: "Eric Larcheveque",
    summary: "Histoire et conseils de l'auteur pour se lancer dans l'entrepreneuriat avec succès.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Esprit d'entreprise & innovation",
    category4: "Se lancer dans l'entrepreunariat",
    nbp: 145,
    id: 978236000000000000,
    tags: "réussite, récit, entrepreneuriat",
    url: "https://www.amazon.fr/dp/2359852272?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41aHfgYrPKL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Et si je n'étais pas Dieu ?",
    author: "Stefania Gander",
    summary: "Réflexion sur l’amour, la perte et la quête de sens.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Se lancer dans l'introspection, la quête de sens et de soi",
    nbp: 122,
    id: 979128000000000000,
    tags: "perte d'un être cher, quête de sens, introspection",
    url: "https://www.amazon.fr/dp/B0DJLFQ2ZL?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61ceygZBn7L._SY342_.jpg",
},
{
    title: "Foutez-vous la paix !",
    author: "Fabrice Midal",
    summary: "Invite à se libérer des injonctions sociales et à s'accepter tel que l'on est pour trouver la paix intérieure.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "S'affirmer et se libérer de la société",
    nbp: 144,
    id: 978236000000000000,
    tags: "récit, confiance en soi, s'affirmer, paix intérieure",
    url: "https://www.amazon.fr/dp/2081404281?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61zHffZ0rEL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Getting Things Done",
    author: "David Allen",
    summary: "Méthodologie GTD pour organiser efficacement ses tâches personnelles et professionnelles. Une méthode claire pour reprendre le contrôle de son temps et de son efficacité.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 134,
    id: 978285000000000000,
    tags: "gestion du temps, prioriser, productivité",
    url: "https://www.amazon.fr/dp/2379350302?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51Cgyntjp8L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Glow Up: Nouveau Mindset, Nouvelle Toi",
    author: "Elsa Mercier",
    summary: "Conseils pour adopter un nouvel état d'esprit et se transformer.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Evoluer , se transformer",
    nbp: 119,
    id: 979832000000000000,
    tags: "se transformer, changer d'état d'esprit",
    url: "https://www.amazon.fr/dp/B0D3F3Z9V3?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51oT00yT11L._SY342_.jpg",
},
{
    title: "Guérir le stress, l'anxiéte, la depression",
    author: "David Servan-Schreiber",
    summary: "Méthodes alternatives sans médicaments ni psychanalyse.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à gérer son stress et l’anxiété",
    nbp: 301,
    id: 2221097629,
    tags: "confiance en soi, gestion du stress, dépression",
    url: "https://www.amazon.fr/dp/2266219510?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41vstFWNcyL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Guérison sentimentale",
    author: "Alice Monet",
    summary: "Guide de reconstruction émotionnelle après une rupture.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 472,
    id: 978226000000000000,
    tags: "rupture, guérir",
    url: "https://www.amazon.fr/dp/B0DR775CYM?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31CfqcokqpL._SY445_SX342_PQ90_.jpg",
},
{
    title: "IKIGAI",
    author: "Takagi Myakano",
    summary: "Philosophie japonaise pour trouver le sens de la vie et l'harmonie.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Se lancer dans l'introspection, la quête de sens et de soi",
    nbp: 108,
    id: 978282000000000000,
    tags: "quête de sens, philosophie, épanouissement",
    url: "https://www.amazon.fr/dp/B0CLN6P8F7?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41dAnm0nXhL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Il était temps, de me sauver moi.",
    author: "Victoire Charlie",
    summary: "Récit personnel sur le chemin de la reconstruction et de la découverte de soi.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Retrouver la paix intérieure",
    category4: "Chercher et trouver la pleine conscience",
    nbp: 318,
    id: 978271000000000000,
    tags: "quête de soi, récit, reconstruction",
    url: "https://www.amazon.fr/dp/B0D73Q17PD?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/21515XpL8QL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Il n'y a pas de hasard, que des rendez-vous",
    author: "Rita Badraoui",
    summary: "Roman de développement personnel pour mieux se comprendre.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 147,
    id: 2897881801,
    tags: "récit, confiance en soi, paix intérieure",
    url: "https://www.amazon.fr/dp/1973198029?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41hEWy1WQjL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Imparfaits, libres et heureux",
    author: "Christophe Andre",
    summary: "Un guide rassurant pour cultiver une estime de soi saine et durable.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 396,
    id: 978274000000000000,
    tags: "estime de soi, vaincre l'anxiété, confiance en soi",
    url: "https://www.amazon.fr/dp/2738145833?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41NFewlG0fL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Influence et manipulation",
    author: "Robert Cialdini",
    summary: "Les principes universels de la persuasion, testés scientifiquement.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Développer ses capacités de Leader",
    nbp: 350,
    id: 978241000000000000,
    tags: "s'affirmer, influence",
    url: "https://www.amazon.fr/dp/2412049696?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41sCW884taL._SY445_SX342_PQ90_.jpg",
},
{
    title: "J'ai broyé du Noir pour voir la vie en Rose",
    author: "Célestine Leroi",
    summary: "Stratégies personnelles et témoignages pour apaiser l’anxiété et cultiver l’optimisme.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Gérer le stress et de l’anxiété",
    nbp: 299,
    id: 978221000000000000,
    tags: "évoluer, gestion du stress, optimisme",
    url: "https://www.amazon.fr/dp/B0CVBTDCTV?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41VCXn62EIL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Je suis épuisé !",
    author: "Cathy Assenheim",
    summary: "Guide pour gérer le burn-out et reprendre le contrôle.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à gérer son stress et l’anxiété",
    nbp: 151,
    id: 978281000000000000,
    tags: "évoluer, gestion du stress, burn-out",
    url: "https://www.amazon.fr/dp/2807337805?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41hs+rHtrOL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Je vais aller mieux",
    author: "Capucine Marc",
    summary: "Propose des pistes pour améliorer son bien-être et retrouver un équilibre personnel. Conseils pratiques pour surmonter l'anxiété et retrouver un bien-être mental.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à gérer son stress et l’anxiété",
    nbp: 207,
    id: 978271000000000000,
    tags: "évoluer, quête de soi, bien-être",
    url: "https://www.amazon.fr/dp/B0CZBS11JC?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/21rv59eZm2L._SY445_SX342_PQ90_.jpg",
},
{
    title: "L’art de la victoire",
    author: "Phil Knight",
    summary: "Le fondateur de Nike raconte l’ascension de son entreprise et les valeurs qui ont forgé sa réussite.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "S'inpirer des réussites",
    nbp: 308,
    id: 2841371875,
    tags: "s'inspirer, réussite, récit",
    url: "https://www.amazon.fr/dp/2755629266?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/418sx23L8YL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La 25e heure",
    author: "Guillaume Declair, Bao Dinh, Jerome Dumont",
    summary: "Techniques pour optimiser son emploi du temps et gagner en productivité.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 224,
    id: 1388943824,
    tags: "gestion du temps, productivité",
    url: "https://www.amazon.fr/dp/2956247409?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41-OkPqjCDL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La boîte à outils du coaching d'équipe",
    author: "Roderic Maubras",
    summary: "75 outils pratiques pour améliorer la performance et la cohésion d’équipe.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre à mieux manager",
    nbp: 377,
    id: 97821000000000000,
    tags: "coaching, management",
    url: "https://www.amazon.fr/dp/2100876031?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/613ySVfWk+L._SY342_.jpg",
},
{
    title: "La clé de votre énergie",
    author: "Natacha Calestreme",
    summary: "Méthodes pour se libérer des blocages émotionnels et retrouver son énergie vitale.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Retrouver la paix intérieure",
    category4: "Retrouver de l'énergie",
    nbp: 201,
    id: 978223000000000000,
    tags: "évoluer, énergie, blocage émotionnel",
    url: "https://www.amazon.fr/dp/2226496173?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/71bLUQEIjWL._SY342_.jpg",
},
{
    title: "La confiance en soi - 7 Barrières Invisibles",
    author: "Lise Mercier",
    summary: "Identifier et surmonter les obstacles internes à la confiance en soi.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Développer la confiance en soi",
    nbp: 69,
    id: 978291000000000000,
    tags: "confiance en soi, s'affirmer, évoluer",
    url: "https://www.amazon.fr/dp/B0DS1C6X7J?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41iVRJLniML._SY445_SX342_PQ90_.jpg",
},
{
    title: "La Confiance en soi, une philosophie",
    author: "Charles Pepin",
    summary: "Exploration philosophique de la confiance en soi.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Développer la confiance en soi",
    nbp: 157,
    id: 978237000000000000,
    tags: "confiance en soi, s'affirmer, philosophie",
    url: "https://www.amazon.fr/dp/2266313568?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31L1zb6uErL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La Guerison des 5 blessures",
    author: "Lise Bourbeau",
    summary: "Identifier et guérir les blessures émotionnelles pour se libérer. Clés pour guérir les blessures émotionnelles et retrouver l'authenticité.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 249,
    id: 2266229486,
    tags: "rupture, guérir",
    url: "https://www.amazon.fr/dp/2266319159?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41-cV0OSxfL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La méthode Coué",
    author: "Emile Coué",
    summary: "Technique d’autosuggestion pour apaiser l’esprit et renforcer la pensée positive.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à se motiver et travailler la pensée positive",
    nbp: 130,
    id: 979104000000000000,
    tags: "pensée positive, évoluer, réussite",
    url: "https://www.amazon.fr/dp/B06XXXC26X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41s0a6HhBdL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La panthère des neiges",
    author: "Sylvain Tesson",
    summary: "Quête de la panthère des neiges sur les plateaux tibétains, réflexion sur la patience et la beauté sauvage.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 124,
    id: 978207000000000000,
    tags: "voyage, récit, nature",
    url: "https://www.amazon.fr/dp/2072822327?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41EuXXYhCOL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La Pensée Positive",
    author: "Angelo Giardino",
    summary: "Utiliser la pensée constructive pour calmer l'anxiété et atteindre ses objectifs. Comment la pensée positive aide à atteindre ses objectifs.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à se motiver et travailler la pensée positive",
    nbp: 100,
    id: 979868000000000000,
    tags: "gestion du stress, réussite, pensée positive",
    url: "https://www.amazon.fr/dp/B0BGJ7RLMQ?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51mPFwIV+cL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La puissance du langage corporel",
    author: "Gerard Shaw",
    summary: "Comprendre et maîtriser la communication non verbale.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 158,
    id: 1958166553,
    tags: "PNL",
    url: "https://www.amazon.fr/dp/B0CJL9W1H7?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41p6bSw9gTL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La Voie du Phoenix",
    author: "Emily Clark",
    summary: "Reconstruction après une relation toxique avec un narcissique.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 191,
    id: "210003135X",
    tags: "toxicité, narcissique, guérir",
    url: "https://www.amazon.fr/dp/B0CH28JR36?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41KeWgXZhnL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'art d'aller à l'essentiel",
    author: "Leo Babauta",
    summary: "Méthode pour simplifier sa vie et se concentrer sur l’essentiel.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Aller à l’essentiel",
    nbp: 172,
    id: 978238000000000000,
    tags: "aller à l'essentiel, changer sa vie, inspiration",
    url: "https://www.amazon.fr/dp/2379351066?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41mtFA+q4iL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'art subtil de s'en foutre",
    author: "Mark Manson",
    summary: "Encourage à lâcher prise et à se concentrer sur l'essentiel pour mener une vie épanouie.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Apprendre à aller à l'essentiel",
    nbp: 305,
    id: 978221000000000000,
    tags: "aller à l'essentiel, lâcher prise, épanouissement",
    url: "https://www.amazon.fr/dp/2212567596?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41GVPi9WPxL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le complexe de la tortue",
    author: "Anne-Claire Froger",
    summary: "Surmonter l’auto-sabotage et oser briller.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Se motiver par un autre mode de pensée",
    nbp: 233,
    id: 2808025505,
    tags: "complexe de l'imposteur, biais cognitifs, pensée positive",
    url: "https://www.amazon.fr/dp/B08F6QNMM5?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41ehWA6mYIL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le Grand Livre du Développement Personnel",
    author: "Daniel Cooper",
    summary: "Recueil d'outils de développement personnel pour libérer son potentiel.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Se motiver par un autre mode de pensée",
    nbp: 163,
    id: 978221000000000000,
    tags: "complexe de l'imposteur, développement personnel, pensée positive",
    url: "https://www.amazon.fr/dp/B0DJMN212G?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41hG8Lm5DmL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le guide pratique de la relaxation dans la gestion du stress",
    author: "Quentin Jacquier",
    summary: "Techniques de relaxation pour rester calme et serein.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à gérer son stress et l’anxiété",
    nbp: 106,
    id: 979836000000000000,
    tags: "méditation, relaxation, gestion du stress",
    url: "https://www.amazon.fr/dp/B0BMJJXB55?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41kgK4x7A8L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le Management bienveillant",
    author: "Philippe Rodet et Yves Desjacques",
    summary: "Un modèle de management basé sur la psychologie positive et la confiance.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre à mieux manager",
    nbp: 168,
    id: 978235000000000000,
    tags: "psychologie positive, management",
    url: "https://www.amazon.fr/dp/2212566719?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41PJxnFQkKL._SX342_SY445_PQ90_.jpg",
},
{
    title: "Le mythe de Sisyphe",
    author: "Albert Camus",
    summary: "Essai philosophique sur l'absurde et la condition humaine.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Travailler sur la quête de soi",
    nbp: 113,
    id: 978207000000000000,
    tags: "philosophie, quête de sens",
    url: "https://www.amazon.fr/dp/2070322882?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41vokzMmbrL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le pouvoir du moment present",
    author: "Eckhart Tolle",
    summary: "Enseignements pour vivre pleinement l’instant présent.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Apprendre à aller à l'essentiel",
    nbp: 284,
    id: 97829000000000000,
    tags: "aller à l'essentiel, lâcher prise, épanouissement",
    url: "https://www.amazon.fr/dp/2813203076?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41MC55+d2xL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le singe et la fleur de lotus",
    author: "Jinpa Sherab",
    summary: "Histoires bouddhistes inspirantes pour transformer la vie quotidienne.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Aller à l’essentiel",
    nbp: 164,
    id: 979885000000000000,
    tags: "changer sa vie, inspiration, philosophie",
    url: "https://www.amazon.fr/dp/B0CCZV2NQ9?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41xK31pQNbL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les Vrais leaders se servent en dernier",
    author: "Simon Sinek",
    summary: "Pourquoi les grands leaders placent leurs équipes en priorité et créent des cultures durables.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre à mieux manager",
    nbp: 192,
    id: 978233000000000000,
    tags: "organisation, management, culture",
    url: "https://www.amazon.fr/dp/2744067393?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51brEpqDFLL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les 5 Piliers du Développement Personnel",
    author: "Angela Rivoli",
    summary: "Compilation sur la communication, langage corporel et développement personnel.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Travailler sa communication aux autres",
    nbp: 100,
    id: 979868000000000000,
    tags: "communication, relations sociales, développement personnel",
    url: "https://www.amazon.fr/dp/B0BW3HQYFK?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41IYVWu0JZL._SX342_SY445_PQ90_.jpg",
},
{
    title: "Les 7 habitudes de ceux qui réalisent tout ce qu’ils entreprennent",
    author: "Stephen Covey",
    summary: "Un classique du développement personnel pour créer des habitudes puissantes et alignées. Habitudes puissantes pour une gestion du temps et une efficacité durables.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Changer ses habitudes",
    nbp: 464,
    id: 2290206059,
    tags: "changer ses habitudes, évoluer, productivité",
    url: "https://www.amazon.fr/dp/2412088667?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61OSEQqXnVL._SY342_.jpg",
},
{
    title: "Les cinq blessures qui empêchent d'être soi-meme",
    author: "Lise Bourbeau",
    summary: "Surmonter les blessures émotionnelles pour être soi-même.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Apprendre à se relever après un echec",
    nbp: 249,
    id: 2266229486,
    tags: "blessure émotionnelle, guérir, quête de soi",
    url: "https://www.amazon.fr/dp/2266229486?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41CU7gpqTRL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les decisions absurdes",
    author: "Christian Morel",
    summary: "Un éclairage fascinant sur les erreurs collectives dans les grandes organisations.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 272,
    id: 2072729092,
    tags: "organisation, management, productivité",
    url: "https://www.amazon.fr/dp/2070457664?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41mZuqI7A6L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les mots sont des fenêtres (ou bien ce sont des murs)",
    author: "Marshall Rosenberg",
    summary: "Une exploration profonde de la communication non violente.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec les autres",
    category4: "Comprendre et améliorer sa communication avec les autres et viser des relations positives",
    nbp: 226,
    id: "284146735X",
    tags: "communication, relations sociales, estime de soi",
    url: "https://www.amazon.fr/dp/2707188794?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61d0rzZtJRL._SY342_.jpg",
},
{
    title: "Les Piliers de la mer",
    author: "Sylvain Tesson",
    summary: "Exploration du lien entre l'homme et la mer à travers des aventures maritimes.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 143,
    id: 978223000000000000,
    tags: "nature, récit, aventure",
    url: "https://www.amazon.fr/dp/2226491325?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51vOopbliGL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les Quatre Accords tolteques",
    author: "Don Miguel Ruiz",
    summary: "Quatre principes spirituels pour la liberté personnelle et le bonheur.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Travailler sur la quête de soi",
    nbp: 103,
    id: 978289000000000000,
    tags: "quête de sens, liberté, bonheur",
    url: "https://www.amazon.fr/dp/B0D32M5XRL?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41L97kqkCUL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les Vertus de l'echec",
    author: "Charles Pepin",
    summary: "Exploration philosophique montrant comment l'échec peut être bénéfique et formateur.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Apprendre à se relever après un echec",
    nbp: 157,
    id: 978237000000000000,
    tags: "échec, philosophie, quête de soi",
    url: "https://www.amazon.fr/dp/2266285424?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31jszXtP3DL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'ethique a Nicomaque",
    author: "Aristote",
    summary: "Traité sur la morale, la vertu et la recherche du bonheur.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Travailler sur la quête de soi",
    nbp: 392,
    id: 978282000000000000,
    tags: "philosophie, bonheur, quête de sens",
    url: "https://www.amazon.fr/dp/2824914165?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/210Wc17ynOL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Libère-toi de tes mots",
    author: "Les livres SUKHA",
    summary: "Thérapie par l’écriture pour guérir les blessures émotionnelles.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Apprendre à se relever après un echec",
    nbp: 108,
    id: 979864000000000000,
    tags: "guérir, blessure émotionnelle, écriture",
    url: "https://www.amazon.fr/dp/B0CFZFK8GV?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41Lvo7Vrm8L._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'Intelligence émotionnelle",
    author: "Viola Di Russo",
    summary: "Développement de l’intelligence émotionnelle pour améliorer les relations.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Spiritualité & sérénité intérieure",
    category4: "S’ouvrir au monde",
    nbp: 226,
    id: 978236000000000000,
    tags: "relations sociales, s'ouvrir",
    url: "https://www.amazon.fr/dp/B091G3P86B?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41FgbF1-VLL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'obstacle est le chemin",
    author: "Ryan Holiday",
    summary: "Une introduction au stoïcisme pour surmonter les défis et transformer les échecs en leviers.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Apprendre à se relever après un echec",
    nbp: 279,
    id: 978238000000000000,
    tags: "philosophie, échec, guérir",
    url: "https://www.amazon.fr/dp/237935443X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41I72dTHZiL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'usage du monde",
    author: "Nicolas Bouvier",
    summary: "Périple à travers l’Asie dans les années 1950, classique de la littérature de voyage.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 418,
    id: "222889401X",
    tags: "aventure, voyage, roman feel-good",
    url: "https://www.amazon.fr/dp/288182370X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/4140qsvWuGL._SX342_SY445_PQ90_.jpg",
},
{
    title: "Ces idées qui collent: Pourquoi certaines idées survivent et d'autres meurent",
    author: "Chip Heath & Dan Heath",
    summary: "Pourquoi certaines idées survivent et d'autres meurent ? Une leçon sur l’impact mémorable.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Travailler et développer sa créativité",
    nbp: 384,
    id: 2081375664,
    tags: "innovation, impact des idées, créativité",
    url: "https://www.amazon.fr/dp/2744066540?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41n3oMkB2FL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Maîtrise du Small Talk (5 en 1)",
    author: "Kirstin Rae Evans",
    summary: "99 techniques pour améliorer les conversations informelles et établir des relations solides.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 93,
    id: 979103000000000000,
    tags: "s'affirmer, savoir présenter",
    url: "https://www.amazon.fr/dp/1964617081?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41CT0LVZkRL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Maîtrisez vos émotions",
    author: "Thibaut Meurisse",
    summary: "Techniques pour comprendre et contrôler ses émotions.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 260,
    id: 979846000000000000,
    tags: "relations sociales, contrôle des émotions, exploration",
    url: "https://www.amazon.fr/dp/B09M5L96T5?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41NirQJPEeL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Méditer jour apres jour",
    author: "Christophe Andre",
    summary: "Une introduction douce et illustrée à la pleine conscience au quotidien.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Retrouver la paix intérieure",
    category4: "Chercher et trouver la pleine conscience",
    nbp: 310,
    id: "237880153X",
    tags: "méditation, pleine conscience, intuition",
    url: "https://www.amazon.fr/dp/2913366376?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51UggK7CPjL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Changer d'état d'esprit: Une nouvelle psychologie de la réussite",
    author: "Carol Dweck",
    summary: "La différence entre mentalité fixe et mentalité de croissance, et leur impact sur la réussite.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "Dévélopper ses capacités",
    nbp: 322,
    id: 97828000000000000,
    tags: "psychologie, réussite, croissance",
    url: "https://www.amazon.fr/dp/2804700348?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31Ydkzvz5ZL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Murmurations amoureuses",
    author: "Alice Monet",
    summary: "Poétique exploration des émotions liées à l’amour et la perte.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 165,
    id: 97827000000000000,
    tags: "philosophie, contrôle des émotions, exploration",
    url: "https://www.amazon.fr/dp/B0DBR8FYRW?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31Jehl2PcgL._SY445_SX342_PQ90_.jpg",
},
{
    title: "On n'ampute pas le coeur",
    author: "Matthieu Lartot",
    summary: "Témoignage sur la résilience et le dépassement de soi face aux épreuves de la vie.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Parcours de vie inspirants",
    category4: "Résilience et épreuves",
    nbp: 134,
    id: 978222000000000000,
    tags: "sport, maladie, résilience",
    url: "https://www.amazon.fr/dp/2221275322?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/31zQBdHIVVL._SY445_SX342_PQ90_.jpg",
},
{
    title: "On ne peut pas plaire à tout le monde",
    author: "Valentin Auwercx",
    summary: "Se libérer du regard des autres et renforcer la confiance en soi. Accepter de ne pas rechercher l’approbation des autres. ",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Développer la confiance en soi",
    nbp: 127,
    id: 979841000000000000,
    tags: "confiance en soi, s'affirmer, relations sociales",
    url: "https://www.amazon.fr/dp/B09RKTVYZM?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41+x7t5s3VL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Open",
    author: "Andre Agassi",
    summary: "Une autobiographie intense d’un champion du tennis en quête de sens et de liberté personnelle.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Parcours de vie inspirants",
    category4: "Univers du sport",
    nbp: 414,
    id: 978226000000000000,
    tags: "sport, motivation, résilience",
    url: "https://www.amazon.fr/dp/2290033243?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41jO5XIR4JL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Pensées pour moi-même, Suivi de Manuel d'Epictete",
    author: "Marc Aurele",
    summary: "Recueil de pensées stoïciennes de l'empereur romain, offrant des réflexions sur la vie.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Aller à l’essentiel",
    nbp: 238,
    id: 2824914599,
    tags: "quête de sens, philosophie, aller à l'essentiel",
    url: "https://www.amazon.fr/dp/B0D5BRRKQY?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51gLcxHmcoL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Père riche, père pauvre",
    author: "Robert T. Kiyosaki",
    summary: "Leçons financières et perspectives alternatives sur l'argent et l'investissement.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Vision & pilotage stratégique",
    category4: "Apprendre sur la gestion financière et l'investissement",
    nbp: 291,
    id: 978292000000000000,
    tags: "gestion financière",
    url: "https://www.amazon.fr/dp/289225955X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51ijjHLLiCL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Petit traité de manipulation à l’usage des honnêtes gens",
    author: "Robert-Vincent Joule & Jean-Leon Beauvois",
    summary: "Un ouvrage accessible et fascinant sur les mécanismes de l’influence au quotidien.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Développer ses capacités de Leader",
    nbp: 366,
    id: "270615604X",
    tags: "influence, s'affirmer",
    url: "https://www.amazon.fr/dp/270615604X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41vyOUglz6L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Petit traité sur l'immensité du monde",
    author: "Sylvain Tesson",
    summary: "Réflexions philosophiques et poétiques sur le voyage et la nature.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 85,
    id: 978285000000000000,
    tags: "philosophie, voyage, nature",
    url: "https://www.amazon.fr/dp/2848681349?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51ut4ex-rkL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'art du pitch",
    author: "Oren Klaff",
    summary: "Maîtriser la dynamique de pouvoir pour faire des présentations irrésistibles.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 271,
    id: 978221000000000000,
    tags: "savoir présenter, s'affirmer",
    url: "https://www.amazon.fr/dp/2212569629?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/315HN53zAHL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Priorité aux priorités",
    author: "Stephen R. Covey",
    summary: "Se concentrer sur ce qui compte vraiment pour mieux gérer son emploi du temps.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 544,
    id: 978281000000000000,
    tags: "gestion du temps, prioriser, productivité",
    url: "https://www.amazon.fr/dp/2290025801?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61G+RcJsCgL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Propos sur le bonheur",
    author: "Alain",
    summary: "Recueil de réflexions sur la quête du bonheur et les moyens de l'atteindre.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Se lancer dans l'introspection, la quête de sens et de soi",
    nbp: 197,
    id: 978249000000000000,
    tags: "quête de sens, philosophie, épanouissement",
    url: "https://www.amazon.fr/dp/2070323218?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51AkkpCQOgL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Reflechissez et devenez riche",
    author: "Napoleon Hill",
    summary: "Un best-seller intemporel sur la puissance de la pensée et des objectifs clairs.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "Dévélopper ses capacités",
    nbp: 405,
    id: 97829000000000000,
    tags: "psychologie, réussite, objectifs",
    url: "https://www.amazon.fr/dp/2354567340?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51flIv8ruhL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Reinventing Organizations",
    author: "Frederic Laloux",
    summary: "Une vision nouvelle des organisations humaines, pour dirigeants et managers en quête de sens.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre à mieux manager",
    nbp: 490,
    id: 2354561059,
    tags: "organisation, management, culture",
    url: "https://www.amazon.fr/dp/2354562519?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51cPv9ISD4L._SX342_SY445_PQ90_.jpg",
},
{
    title: "Gagner",
    author: "Tim Grover",
    summary: "L’entraîneur des plus grands (Jordan, Kobe, Wade) dévoile la mentalité du champion.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Parcours de vie inspirants",
    category4: "Univers du sport",
    nbp: 266,
    id: 978238000000000000,
    tags: "motivation, sport, influence",
    url: "https://www.amazon.fr/dp/2378152299?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41K4mfrCfHL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Réparer les Fractures de l’Âme",
    author: "Daniel TU",
    summary: "Méthodes de guérison des blessures émotionnelles profondes.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 249,
    id: 2266229486,
    tags: "guérir, blessure émotionnelle, aller mieux",
    url: "https://www.amazon.fr/dp/B0DY5L7284?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61SnmzbbikL._SY342_.jpg",
},
{
    title: "Reprogrammation mentale",
    author: "Robert Mercier",
    summary: "Techniques de succès pour lever les blocages mentaux et atteindre ses objectifs.",
    category1: "Aller mieux",
    category2: "Acquérir des compétences de vie",
    category3: "Mieux vivre avec soi-même",
    category4: "Apprendre à se motiver et travailler la pensée positive",
    nbp: 164,
    id: 979822000000000000,
    tags: "psychologie, auto-persuasion, réussite",
    url: "https://www.amazon.fr/dp/B0B6L9GJDR?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41vHVsyRYmL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Rework : : réussir autrement",
    author: "Jason Fried & David Heinemeier Hansson",
    summary: "Un manifeste contre les idées reçues de l’entreprise traditionnelle.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Apprendre à être plus effficace et productif",
    nbp: 201,
    id: 978282000000000000,
    tags: "productivité, penser autrement, impact des idées",
    url: "https://www.amazon.fr/dp/2100846140?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41Texmz9aEL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Rien à perdre",
    author: "Jonathan Anguelov",
    summary: "Parcours inspirant de l'auteur, d'une enfance difficile à la création d'une entreprise valorisée à plus d'un milliard d'euros. Parcours inspirant d’un entrepreneur à succès.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "S'inpirer des réussites",
    nbp: 147,
    id: 978238000000000000,
    tags: "s'inspirer, réussite, récit",
    url: "https://www.amazon.fr/dp/2379354413?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41M9M7BD-oL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Petit traité de vie intérieure",
    author: "Frédéric Lenoir",
    summary: "Un voyage vers soi mêlant sagesse, spiritualité et introspection.",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Trouver du sens",
    category4: "Se lancer dans l'introspection, la quête de sens et de soi",
    nbp: 135,
    id: 978226000000000000,
    tags: "quête de sens, philosophie, épanouissement",
    url: "https://www.amazon.fr/dp/2266215299?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41cfKkdQ1RL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Trouver son pourquoi: Guide pratique pour découvrir son moteur et celui de son équipe",
    author: "Simon Sinek",
    summary: "Les leaders qui inspirent commencent toujours par le ‘Pourquoi’.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Développer ses capacités de Leader",
    nbp: 230,
    id: 2924412684,
    tags: "management, influence, coaching",
    url: "https://www.amazon.fr/dp/2744066923?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41Pwptzs8VL._SX342_SY445_PQ90_.jpg",
},
{
    title: "Stress SOS Mode d'Emploi",
    author: "Chantal Labeste",
    summary: "Programme de 21 jours pour gérer le stress et les émotions.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Gérer le stress et de l’anxiété",
    nbp: 248,
    id: 978281000000000000,
    tags: "burn-out, gestion du stress, optimisme",
    url: "https://www.amazon.fr/dp/B0F1YB2LJ4?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41K0NI+ZRDL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Supercommunicators",
    author: "Charles Duhigg",
    summary: "Secrets des communicateurs efficaces et stratégies pour se connecter aux autres.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "S’affirmer et mieux gérer ses émotions",
    category4: "Travailler sa communication aux autres",
    nbp: 320,
    id: "nan",
    tags: "communication, relations sociales, leadership",
    url: "https://www.amazon.fr/dp/2080266403?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61dhqWtyzML._SY445_SX342_PQ90_.jpg",
},
{
    title: "Système 1 / Système 2 : Les deux vitesses de la pensée",
    author: "Daniel Kahneman",
    summary: "Une plongée dans nos biais cognitifs et nos mécanismes inconscients de prise de décision.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à faire des choix",
    nbp: 262,
    id: 978208000000000000,
    tags: "faire des choix, changer d'état d'esprit, biais cognitifs",
    url: "https://www.amazon.fr/dp/2081211475?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61Xr7ZNkMZL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Ta deuxième vie commence quand tu comprends que tu n’en as qu’une",
    author: "Raphaëlle Giordano",
    summary: "Un roman feel-good pour se reconnecter à ses rêves et prendre sa vie en main.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Aller à l’essentiel",
    nbp: 299,
    id: 978221000000000000,
    tags: "roman feel-good, introspection, aller à l'essentiel",
    url: "https://www.amazon.fr/dp/2416014293?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41XAA4PFPML._SY445_SX342_PQ90_.jpg",
},
{
    title: "Les 21 qualités indispensables à tout leader",
    author: "John C. Maxwell",
    summary: "Des lois universelles pour devenir un leader efficace et influent.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Développer ses capacités de Leader",
    nbp: 336,
    id: 2922713237,
    tags: "influence, s'affirmer",
    url: "https://www.amazon.fr/dp/2925337147?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41YOgKoZ9qL._SY445_SX342_PQ90_.jpg",
},
{
    title: "La Carte des différences culturelles - 8 clés pour travailler à l'international",
    author: "Erin Meyer",
    summary: "Exploration des différences culturelles et de leur impact sur la communication et les affaires.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 304,
    id: 978235000000000000,
    tags: "management, culture, international",
    url: "https://www.amazon.fr/dp/2354564821?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41884DdfUHL._SY445_SX342_PQ90_.jpg",
},
{
    title: "The Lean Startup : Adoptez l'innovation continue",
    author: "Eric Ries",
    summary: "La bible pour créer rapidement une startup et tester son marché avec agilité.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Esprit d'entreprise & innovation",
    category4: "Se lancer dans l'entrepreunariat",
    nbp: 320,
    id: 2744066400,
    tags: "réussite, startup, entrepreneuriat",
    url: "https://www.amazon.fr/dp/2744066400?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41f5Mzi0i-L._SY445_SX342_PQ90_.jpg",
},
{
    title: "The one thing: Passez à l'essentiel",
    author: "Gary Keller",
    summary: "Se concentrer sur l’essentiel pour obtenir des résultats puissants et durables.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Apprendre à être plus effficace et productif",
    nbp: 189,
    id: 978238000000000000,
    tags: "productivité, penser autrement, aller à l'essentiel",
    url: "https://www.amazon.fr/dp/2379350477?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/418nyyWbABL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le pouvoir des habitudes: Changer un rien pour tout changer",
    author: "Charles Duhigg",
    summary: "Exploration de la science des habitudes et méthodes pour les changer.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Efficacité & développement personnel au travail",
    category4: "Changer ses habitudes",
    nbp: 364,
    id: 978208000000000000,
    tags: "changer ses habitudes, évoluer, productivité",
    url: "https://www.amazon.fr/dp/2080295934?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41xTiH+31JL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Tout le monde n’a pas eu la chance de rater ses études",
    author: "Olivier Roland",
    summary: "Approche alternative de l’apprentissage et du temps libre pour entreprendre efficacement. Une alternative à l'éducation classique pour réussir dans l'entrepreneuriat.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Esprit d'entreprise & innovation",
    category4: "Se lancer dans l'entrepreunariat",
    nbp: 480,
    id: 979109000000000000,
    tags: "réussite, leçon de vie, entrepreneuriat",
    url: "https://www.amazon.fr/dp/2253238678?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41SM4KnNXSL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Tu naïs seul mais tu n'es pas seul",
    author: "Capucine Marc",
    summary: "Réflexions sur la solitude existentielle et son acceptation.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "Estime et amour de soi",
    nbp: 84,
    id: 978223000000000000,
    tags: "estime de soi, vaincre l'anxiété, récit",
    url: "https://www.amazon.fr/dp/B0DV957PN8?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/21RdvGTplfL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Renversez la vapeur !: L'histoire d'un capitaine qui a su transformer des exécutants en leaders",
    author: "L. David Marquet",
    summary: "Comment transformer les équipes en leur redonnant autonomie et responsabilité.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre à mieux manager",
    nbp: 192,
    id: 978233000000000000,
    tags: "organisation, management",
    url: "https://www.amazon.fr/dp/2892259924?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41VpYq6NKKL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Un cerveau pour changer",
    author: "Richard Bandler",
    summary: "Utiliser la PNL pour initier des changements positifs.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Communication & leadership",
    category4: "Apprendre et améliorer sa communication",
    nbp: 307,
    id: 2761920414,
    tags: "PNL, psychologie positive",
    url: "https://www.amazon.fr/dp/2729618333?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41BcRaBvU1L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Un rien peut tout changer: Atomic Habits",
    author: "James Clear",
    summary: "Méthodes pour créer de petites habitudes aux effets puissants.",
    category1: "Développer ses compétences",
    category2: "Développement personnel",
    category3: "Changer ses habitudes et mieux s’organiser",
    category4: "Apprendre à maîtriser le temps et sa concentration",
    nbp: 338,
    id: 1698414684,
    tags: "productivité, changer d'état d'esprit, organisation, développement personnel",
    url: "https://www.amazon.fr/dp/2035969204?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41FEfeXhunL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Une rupture goût framboise",
    author: "Capucine Marc",
    summary: "Exploration émotionnelle d’une rupture amoureuse.",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Guérir ses blessures émotionnelles",
    category4: "Comprendre et apprendre à guérir émotionnellement",
    nbp: 376,
    id: 978276000000000000,
    tags: "rupture, blessure émotionnelle, exploration",
    url: "https://www.amazon.fr/dp/B0CKPXY84K?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/21l7OJvW60L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Wild",
    author: "Cheryl Strayed",
    summary: "Un voyage de rédemption et de survie sur les sentiers de la côte ouest américaine.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Vivre des expériences humaines fortes",
    category3: "Aventure & dépassement",
    category4: "Univers du voyage, de la nature",
    nbp: 484,
    id: 978208000000000000,
    tags: "voyage, aventure, récit",
    url: "https://www.amazon.fr/dp/2264062207?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41L1NBozTJL._SY445_SX342_PQ90_.jpg",
},
{
    title: "De zéro à un",
    author: "Peter Thiel",
    summary: "Penser différemment pour créer des entreprises qui changent le monde.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Esprit d'entreprise & innovation",
    category4: "Changer, découvrir de nouveaux horizons dans sa carrière",
    nbp: 408,
    id: 2710119587,
    tags: "penser différemment, leçon de vie, entrepreneuriat",
    url: "https://www.amazon.fr/dp/2709649314?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/415QLoxLJRL._SY445_SX342_PQ90_.jpg",
},
{
    title: "L'alchimiste",
    author: "Paulo Coelho",
    summary: "Conte philosophique et voyage initiatique aux rencontres improbables permettant au héros d'accomplir la quête de soi et de découvrir sa Légende personnelle.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Introspection & quête personnelle",
    category4: "Travailler sur la quête de soi",
    nbp: 154,
    id: 978208000000000000,
    tags: "philosophie, roman feel-good, introspection",
    url: "https://www.amazon.fr/dp/2290258067?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41SU2d2rvfL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Libérées !",
    author: "Titou Lecoq",
    summary: "Le combat féministe se gagne devant le panier de linge sale",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "S'affirmer et se libérer en temps que femme",
    nbp: 202,
    id: 978221000000000000,
    tags: "histoire de femme, s'affirmer, récit",
    url: "https://www.amazon.fr/dp/2253091693?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41iXFm1g9BL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Pourquoi l'histoire a effacé les femmes",
    author: "Titou Lecoq",
    summary: "Pourquoi l'histoire a effacé les femmes",
    category1: "Aller mieux",
    category2: "Épanouissement personnel",
    category3: "Améliorer son bien-être émotionnel",
    category4: "S'affirmer et se libérer en temps que femme",
    nbp: 223,
    id: 2493909461,
    tags: "histoire de femme, s'affirmer, récit",
    url: "https://www.amazon.fr/dp/2493909461?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/412omptFqoL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Energie Quantique",
    author: "Siranus Sven Von Staden",
    summary: "Véritable voyage aux frontières de la conscience, cet ouvrage enquête sur les pouvoirs de l’intuition comme levier de guérison. ",
    category1: "Aller mieux",
    category2: "Bien-être & spiritualité",
    category3: "Retrouver la paix intérieure",
    category4: "Retrouver de l'énergie",
    nbp: 161,
    id: 978204000000000000,
    tags: "récit, pleine conscience, intuition",
    url: "https://www.amazon.fr/dp/284933989X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41oIiFn-xwL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Le monde de Sophie",
    author: "Gaarder Jostein",
    summary: "Roman sur l'histoire de la philosophie, nous amenant à savoir qui nous sommes et pourquoi nous vivons.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Se reconnecter à soi & trouver du sens",
    category3: "Spiritualité & sérénité intérieure",
    category4: "Réflechir sur l'éthique, la morale et la société",
    nbp: 617,
    id: 2020550768,
    tags: "philosophie, roman feel-good, s'ouvrir",
    url: "https://www.amazon.fr/dp/2020550768?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51XW64ziD2L._SY445_SX342_PQ90_.jpg",
},
{
    title: "Éthique à Nicomaque",
    author: "Aristote",
    summary: "Un classique fondateur de la philosophie morale, idéal pour réfléchir aux fondements de la société.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Réflexion éthique & société",
    category4: "Morale et société",
    nbp: 574,
    id: "nan",
    tags: "philosophie, comprendre la société",
    url: "https://www.amazon.fr/dp/208070947X?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61O7YBmXdVL._SY445_SX342_ControlCacheEqualizer_.jpg",
},
{
    title: "Sapiens : Une brève histoire de l’humanité",
    author: "Yuval Noah Harari",
    summary: "Une analyse critique de l’évolution de notre civilisation, très accessible et provocante.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Réflexion éthique & société",
    category4: "Morale et société",
    nbp: 506,
    id: "nan",
    tags: "comprendre la société, humanité",
    url: "https://www.amazon.fr/dp/2226479821?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/71d0caFaVfL._SY425_.jpg",
},
{
    title: "Petit traité de vie intérieure",
    author: "Frédéric Lenoir",
    summary: "Un voyage vers soi mêlant sagesse, spiritualité et introspection.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Réflexion éthique & société",
    category4: "Valeurs humaines",
    nbp: 135,
    id: 978226000000000000,
    tags: "philosophie, spiritualité, introspection",
    url: "https://www.amazon.fr/dp/2266215299?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41cfKkdQ1RL._SY445_SX342_PQ90_.jpg",
},
{
    title: "Nous sommes tous des féministes",
    author: "Chimamanda Ngozi Adichie",
    summary: "Un témoignage fort sur l'engagement social, accessible et universel.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Engagement & témoignages sociaux",
    category4: "Témoignages engagés",
    nbp: 80,
    id: "nan",
    tags: "engagement social, inégalités, histoire de femme",
    url: "https://www.amazon.fr/dp/2073007635?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41geU2SUyZL._SY445_SX342_ControlCacheEqualizer_.jpg",
},
{
    title: "Le capital au XXIe siècle",
    author: "Thomas Piketty",
    summary: "Un ouvrage majeur sur les inégalités économiques et sociales.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Engagement & témoignages sociaux",
    category4: "Société",
    nbp: 972,
    id: "nan",
    tags: "inégalités, comprendre la société",
    url: "https://www.amazon.fr/dp/2757884581?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61mM-ce0WQL._SY425_.jpg",
},
{
    title: "La société du spectacle",
    author: "Guy Debord",
    summary: "Une critique radicale des mécanismes sociaux modernes, toujours d’actualité.",
    category1: "S'inspirer, découvrir, s'évader",
    category2: "Observer, comprendre & s'engager",
    category3: "Engagement & témoignages sociaux",
    category4: "Société",
    nbp: 224,
    id: "nan",
    tags: "inégalités, comprendre la société",
    url: "https://www.amazon.fr/dp/2072779405?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/51mYqCzeYGL._SY445_SX342_ControlCacheEqualizer_.jpg",
},
{
    title: "L’autoroute du millionnaire",
    author: "MJ DeMarco",
    summary: "Une vision provocante sur l’entrepreneuriat, les modèles de richesse, et la prise de contrôle de sa carrière.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Vision & pilotage stratégique",
    category4: "Apprendre sur la gestion financière et l'investissement",
    nbp: 501,
    id: "nan",
    tags: "entrepreneuriat, gestion financière",
    url: "https://www.amazon.fr/dp/2849334650?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61aeM-d3u5L._SY466_.jpg",
},
{
    title: "La psychologie de l'argent: Quelques leçons intemporelles sur la richesse, la cupidité et le bonheur",
    author: "Morgan Housel",
    summary: "Une approche comportementale de l’argent : pourquoi ce n’est pas qu’une question de mathématiques, mais aussi d’émotions.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Vision & pilotage stratégique",
    category4: "Apprendre sur la gestion financière et l'investissement",
    nbp: 291,
    id: "nan",
    tags: "gestion financière, psychologie",
    url: "https://www.amazon.fr/dp/2361170566?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/71+LvE3vYKL._SY425_.jpg",
},
{
    title: "Commencer par Pourquoi - Comment les grands leaders nous inspirent à passer à l'action",
    author: "Simon Sinek",
    summary: "Pour comprendre comment une vision claire peut inspirer, fédérer et orienter ses actions dans la durée.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Vision & pilotage stratégique",
    category4: "Vision stratégique",
    nbp: 230,
    id: "nan",
    tags: "management, influence",
    url: "https://www.amazon.fr/dp/2924412684?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41kpfTkAz0L._SY445_SX342_ControlCacheEqualizer_.jpg",
},
{
    title: "Système 1, système 2 : Les deux vitesses de la pensée",
    author: "Daniel Kahneman",
    summary: "Un chef-d'œuvre sur les biais cognitifs qui influencent nos décisions stratégiques.",
    category1: "Développer ses compétences",
    category2: "Booster sa carrière",
    category3: "Vision & pilotage stratégique",
    category4: "Vision stratégique",
    nbp: 706,
    id: "nan",
    tags: "management, influence",
    url: "https://www.amazon.fr/dp/2081307820?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/61Ll4raDHRL._SY445_SX342_ControlCacheEqualizer_.jpg",
},
{
    title: "La semaine de 4 heures",
    author: "Tim Ferriss",
    summary: "Une approche provocante pour redéfinir sa vie pro : déléguer, voyager, et entreprendre autrement.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "Dévélopper ses capacités",
    nbp: 320,
    id: "nan",
    tags: "psychologie, réussite, entreprendre",
    url: "https://www.amazon.fr/dp/2744064173?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/71xXrddBk7L._SY385_.jpg",
},
{
    title: "L’entreprise du bonheur",
    author: "Tony Hsieh",
    summary: "Comment un leader a réinventé la culture d’entreprise avec audace et humanité chez Zappos.",
    category1: "Développer ses compétences",
    category2: "Se lancer de nouveaux défis",
    category3: "Ambition & dépassement de soi",
    category4: "S'inpirer des réussites",
    nbp: 320,
    id: "nan",
    tags: "s'inspirer, réussite, culture",
    url: "https://www.amazon.fr/dp/2379354286?tag=monprochain0a-21",
    cover: "https://m.media-amazon.com/images/I/41D8Z3961hL._SY445_SX342_ControlCacheEqualizer_.jpg",
}
];

export default bookDatabase;